// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".defaultMessageDiv_I9ruR {\n  max-width: 60vw;\n  text-align: center;\n}", "",{"version":3,"sources":["webpack://./components/ErrorBoundary/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,kBAAA;AACJ","sourcesContent":[".defaultMessageDiv {\r\n    max-width: 60vw;\r\n    text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultMessageDiv": "defaultMessageDiv_I9ruR"
};
export default ___CSS_LOADER_EXPORT___;
